<!-- eslint-disable -->
<template lang="pug">
    .control-buttons
        .control-buttons__button(v-if="((user.type === 'student' || user.type === 'olympiad-student') && user.pointsAccesses.length > 1)")
            cs-button(
                pattern="primary-outline"
                color="white"
                @click="openModal"
            )
                span {{ $i18n.t('common.common_course_changeCourse') }}
                svg-icon.button__icon(name="angle" size="small", height="xx-small" )
        template(v-else-if="user.type !== 'student' && user.type !== 'olympiad-student' && stats")
            .control-buttons__button(v-if="user.isSuperadmin || user.isManagerOrSupport")
                cs-button(
                    :color="!buttonColor && 'white' || buttonColor",
                    pattern="primary-outline",
                    :style="greenButtonStyle"
                    @click="$router.push({name: 'user:list', params: {type: 'admin'}})"
                )
                    | {{ $i18n.t('dashboard.dashboard_appHeader_admins') }}
                    svg-icon.button__icon--center.button__icon--yellow(name="profile", size="large")
                    | {{ stats.amountOfAdmins }}
            .control-buttons__button
                cs-button(
                    :color="!buttonColor && 'white' || buttonColor",
                    pattern="primary-outline",
                    :style="greenButtonStyle"
                    @click="$router.push({name: 'user:list', params: {type: 'teacher'}})"
                )
                    | {{ $i18n.t('dashboard.dashboard_appHeader_teachers') }}
                    svg-icon.button__icon.button__icon--center.button__icon--yellow(name="profile", size="large")
                    | {{ stats.amountOfTeachers }}
            .control-buttons__button
                cs-button(
                    :color="!buttonColor && 'white' || buttonColor",
                    pattern="primary-outline",
                    :style="greenButtonStyle"
                    @click="$router.push({name: 'user:list', params: {type: 'student'}})"
                )
                    | {{ $i18n.t('dashboard.dashboard_appHeader_students') }}
                    svg-icon.button__icon.button__icon--center.button__icon--yellow(name="profile", size="large")
                    | {{ stats.amountOfStudents }}
            .control-buttons__button
                cs-button(
                    :color="!buttonColor && 'white' || buttonColor",
                    pattern="primary-outline",
                    :style="greenButtonStyle"
                    @click="$router.push({name: 'grade:list'})"
                )
                    | {{ $i18n.t('dashboard.dashboard_appHeader_grades') }}
                    svg-icon.button__icon.button__icon--center.button__icon--yellow(name="list", size="large")
                    | {{ stats.amountOfGrades }}
        cs-modal(v-if="isModalOpened" @close="closeModal" :color="true")
            .modal__text
                | {{ $i18n.t('common.common_course_changeCourse') }}
            .modal__buttons
                .modal__button-container(v-for="course in user.pointsAccesses")
                    cs-button(
                        color="white"
                        :fullWidth="true"
                        @click="selectCourse(course)"
                    ) {{ $i18n.t('common.common_course_' + course) }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'

    import UserApi from '../../api/user/user'

    import CsModal from '../../elements/CsModal.vue'

    export default {
        props: {
            buttonColor: {
                type: String,
                default: ''
            }
        },
        watch: {
            user: {
                handler (val) {
                    if (!this.$offline) {
                        this.getStats();
                    }
                },
                immediate: true
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            greenButtonStyle () {
                return this.buttonColor && {'font-weight': 500}
            }
        },
        components: {CsModal},
        data () {
            return {
                stats: null,
                isModalOpened: false,
            }
        },
        methods: {
            getStats () {
                UserApi.amounts()
                .then(response => {
                    this.stats = response.data;
                })
                .catch(err => {
                    this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                });
            },
            openModal () {
                this.isModalOpened = true;
            },
            closeModal () {
                this.isModalOpened = false;
            },
            selectCourse(course) {
                this.$store.dispatch('setCourse', course);
                this.closeModal();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .control-buttons {
        display: none;
        @include media($xlg) {
            display: flex;
            flex-direction: row;
            margin: 0 -10px;
        }
    }

    .control-buttons__button {
        display: block;
        padding: 10px;
    }

    .control-buttons__button .cs-button {
        font-size: 18px;
        line-height: 21px;
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
    }

    .button__icon {
        margin-left: $space-x-small;
    }

    .button__icon--yellow {
        color: $hsl-color-yellow-66;
    }

    .button__icon--center {
        margin: 0 5px 0 10px;
    }


    .modal__text {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        color: $x-color-white;
    }

    .modal__buttons {
        padding-top: 25px;
        max-width: 260px;
        margin: 0 auto;
    }

    .modal__button-container {
        padding-top: 10px;
    }
</style>
